import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../Components/Forms/renders";

const TemplateForm = (props) => {
  const { handleSubmit, pristine, submitting } = props;

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field
                name="name"
                type="input"
                validate={[required()]}
                component={renderField}
                label="Naam Sjabloon"
              />

              <Field
                name="description"
                type="input"
                component={renderTextField}
                label="Beschrijving"
              />

              <Field
                name="category"
                type="input"
                validate={[required()]}
                component={renderselect}
                options={{
                  algemeen: "Algemeen",
                  veiligheid: "Veiligheid",
                  "hygiëne": "Hygiëne",
                  technisch: "Technisch",
                  legionella: "Legionella",
                  chemisch: "Chemisch"
                }}
                label="Categorie"
              />

              <Field
                name="version"
                type="input"
                component={renderField}
                label="Versie"
                placeholder="1.0"
              />

              <Field
                name="is_default"
                type="input"
                component={renderselect}
                options={{
                  false: "Nee",
                  true: "Ja"
                }}
                label="Standaard sjabloon"
              />

              <Field
                name="is_active"
                type="input"
                component={renderselect}
                options={{
                  true: "Actief",
                  false: "Inactief"
                }}
                label="Status"
              />
            </div>
          </div>

          <div className="pull-left submit mt-3">
            <button
              type="submit"
              className="btn btn-success btn-wd"
              disabled={pristine || submitting}
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

let ReduxTemplateForm = reduxForm({
  form: "template_form",
  enableReinitialize: true
})(TemplateForm);

ReduxTemplateForm = connect((state) => ({
  initialValues: state.zwembadinspecties.inspectionTemplate || {
    is_active: true,
    is_default: false,
    category: 'algemeen',
    version: '1.0'
  }
}))(ReduxTemplateForm);

export default ReduxTemplateForm;
